import Dashboard from './StatisticDashboard';

export default {
  displayNameKey: 'status',
  icon: 'menu_dashboard',
  dftOpen: true,
  pages: {
    Dashboard,
  },
};



// WEBPACK FOOTER //
// ./src/modules/Status/index.js